// useSideMenu.js
import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import iconLight from '../assets/img/brand/icon-light.png';
import logoIcon from '../assets/img/brand/icon.png';
import smarpayLightLogo from '../assets/logo/smarpay-logo-light-small.png';
import smarpayLogoSmall from '../assets/logo/smarpay-logo-small.png';


function useSideMenu(initialMenu = []) {
    const [menuItemsState, setMenuItemsState] = useState([]);
    const [menuIcontype, setMenuIcontype] = useState('hor-icon')
    const location = useLocation();

    useEffect(() => {
        setMenuItemsState(initialMenu)
    }, [initialMenu])

    //MenuIconType
    useEffect(() => {
        if (document.querySelector("body").classList.contains("horizontalmenu")) {
            setMenuIcontype("hor-icon")
        } else {
            setMenuIcontype("sidemenu-icon")
        }
    }, [document.querySelector("body").classList.contains("horizontalmenu")])


    function toggleSidemenu(item) {
        if (
            !document.body.classList.contains("horizontalmenu-hover") ||
            window.innerWidth < 992
        ) {
            // To show/hide the menu
            if (!item.active) {
                menuItemsState.filter((mainlevel) => {
                    if (mainlevel.Items) {
                        mainlevel.Items.filter((sublevel) => {
                            sublevel.active = false;
                            if (item === sublevel) {
                                sublevel.active = true;
                            }
                            if (sublevel.children) {
                                sublevel.children.filter((sublevel1) => {
                                    sublevel1.active = false;
                                    if (item === sublevel1) {
                                        sublevel.active = true;
                                        sublevel1.active = true;
                                    }
                                    if (sublevel1.children) {
                                        sublevel1.children.filter((sublevel2) => {
                                            sublevel2.active = false;
                                            if (item === sublevel2) {
                                                sublevel.active = true;
                                                sublevel1.active = true;
                                                sublevel2.active = true;
                                            }
                                            return sublevel2;
                                        });
                                    }
                                    return sublevel1;
                                });
                            }
                            return sublevel;
                        });
                    }
                    return mainlevel;
                });
            } else {
                item.active = !item.active;
            }
            setMenuItemsState((arr) => [...arr]);
        }
    }

    function updateMenuItems(menuItems = []) {
        if (menuItems.length) {
            menuItems.forEach((item) => {
                item.active = false;
                item.selected = false;

                /*if (location.pathname === LocationPaths.Preview) {
                  location.pathname = LocationPaths.Dashboard;
                }*/

                if (location.pathname === item.path + "/") {
                    item.active = true;
                    item.selected = true;
                }

                if (item.children) {
                    item.children.forEach((submenu) => {
                        submenu.active = false;
                        submenu.selected = false;

                        if (location.pathname === submenu.path + "/") {
                            item.active = true;
                            item.selected = true;
                            submenu.active = true;
                            submenu.selected = true;
                        }

                        if (submenu.children) {
                            submenu.children.forEach((submenu1) => {
                                submenu1.active = false;
                                submenu1.selected = false;

                                if (location.pathname === submenu1.path + "/") {
                                    item.active = true;
                                    item.selected = true;
                                    submenu.active = true;
                                    submenu.selected = true;
                                    submenu1.active = true;
                                    submenu1.selected = true;
                                }
                            });
                        }
                    });
                }

                updateMenuItems(item.Items);
            });
        }
    }

    function clearMenuActive(initialMenu = []) {
        initialMenu.filter((mainlevel) => {
            if (mainlevel.Items) {
                mainlevel.Items.filter((sublevel) => {
                    sublevel.active = false;
                    if (sublevel.children) {
                        sublevel.children.filter((sublevel1) => {
                            sublevel1.active = false;
                            if (sublevel1.children) {
                                sublevel1.children.filter((sublevel2) => {
                                    sublevel2.active = false;
                                    return sublevel2;
                                });
                            }
                            return sublevel1;
                        });
                    }
                    return sublevel;
                });
            }
            return mainlevel;
        });
        setMenuItemsState((arr) => [...arr]);
    }

    //3. THIRD LEVEL OF MENU (CHILD > CHILDREN)
    const printChildrenSubmenu = (menuItem, childrenItem) => {
        return (<ul
            className="sub-nav-sub"
            style={
                childrenItem.active
                    ? { display: "block" }
                    : { display: "none" }
            }
        >
            {childrenItem.children.map(
                (childrenSubItem, key) => (
                    <li
                        className={`nav-sub-item ${childrenSubItem.selected && "active"} ${menuItem.highlighted ? "highlighted" : ""}`}
                        key={key}
                    >
                        {childrenSubItem.type ===
                            "link" && (
                                <NavLink
                                    onClick={(e) => menuItem.disabled && e.preventDefault()}
                                    to={
                                        childrenSubItem.path + "/"
                                    }
                                    className={`nav-sub-link ${menuItem.disabled ? "disabled" : ""}`}
                                >
                                    {childrenSubItem.title}
                                </NavLink>
                            )}

                        {childrenSubItem.type ===
                            "sub" && (
                                <Link
                                    to="#"
                                    className="nav-sub-item"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        if (!menuItem.disabled) toggleSidemenu(childrenSubItem);
                                    }}
                                >
                                    <span className="sidemenu-label">
                                        {childrenSubItem.title}
                                    </span>
                                    {childrenSubItem.active ? (
                                        <i className="fa fa-angle-down"></i>
                                    ) : (
                                        <i className="fa fa-angle-right"></i>
                                    )}
                                </Link>
                            )}
                    </li>
                )
            )}
        </ul>
        )
    }

    //2. SECOND LEVEL OF MENU (MENU > CHILDREN)
    const printChildrenMenu = (menuItem, childrenItem) => {

        const activeChild = childrenItem.active ? (
            <i className="angle fa fa-angle-down"></i>
        ) : (
            <i
                className={`${menuItem.background} fa angle fa-angle-right `}
            ></i>
        )

        //childrenItem.type === "sub"
        const childSub = childrenItem.type === "sub" && (
            <a
                href="javascript"
                className="nav-sub-link sub-with-sub"
                onClick={(event) => {
                    event.preventDefault();
                    if (!menuItem.disabled) toggleSidemenu(childrenItem);
                }}
            >
                <span className="sidemenu-label">
                    {childrenItem.title }
                    {childrenItem.active}
                </span>
                {activeChild}
            </a>
        )

        //childrenItem.type === "link"
        const childLink = childrenItem.type === "link" && (
            (
                <NavLink
                    onClick={(e) => menuItem.disabled && e.preventDefault()}
                    to={childrenItem.path + "/"}
                    className={`nav-sub-link ${menuItem.disabled ? "" : ""}`}
                    disabled={menuItem.disabled ? true : false}
                >
                    {childrenItem.title}
                </NavLink>
            )
        )


        //childrenItem.children - THIRD MENU LEVEL !!!
        const childHasChildren = childrenItem.children && printChildrenSubmenu(menuItem, childrenItem)


        //return childSub || childLink || childHasChildren
        return (
            <>
                {childSub}
                {childLink}
                {childHasChildren}
            </>
        )
    }

    //1. FIRST LEVEL OF SIDE MENU
    const printSideMenu = (menuItem) => {

        const menuItemBadge = menuItem.badge && (
            <label className={menuItem.badge}>
                {menuItem.badgetxt}
            </label>)

        const MenuIconComponent = <i
            className={`${menuItem.icon} ${menuIcontype} menu-icon`}
        ></i>

        //console.log("menuItem ===> ", menuItem)

        const menuSubtitles = menuItem.type === "sub" && (
            <a
                href="javascript"
                className={`nav-link with-sub ${menuItem.disabled ? "disabled" : ""}`}
                onClick={(event) => {
                    event.preventDefault();
                    if (!menuItem.disabled) toggleSidemenu(menuItem);
                }}
            >
                <span className="shape1"></span>
                <span className="shape2"></span>

                {MenuIconComponent}
                
                <span className={`sidemenu-label`}>
                    {menuItem.title}
                    {menuItem.active}
                </span>

                {menuItemBadge}

                <div className="according-menu">
                    {menuItem.active ? (
                        <i
                            className={`${menuItem.background} fa angle fa-angle-down `}
                        ></i>
                    ) : (
                        <i
                            className={`${menuItem.background} ${menuItem.disabled ? "disabled" : ""}  fa angle fa-angle-right `}
                        ></i>
                    )}
                </div>
            </a>)
        const menuLink = menuItem.type === "link" && (
            <NavLink
                onClick={(e) => menuItem.disabled && e.preventDefault()}
                to={menuItem.path === "/" ? menuItem.path : menuItem.path + "/"}
                className={`nav-link ${menuItem.selected ? "active" : ""} ${menuItem.highlighted ? "highlighted" : ""} ${menuItem.disabled ? "disabled" : ""}`}
            >
                <i
                    className={`${menuItem.icon} ${menuIcontype} menu-icon`}
                ></i>
                <span className="sidemenu-label">
                    {menuItem.title}
                </span>
                {menuItemBadge}
            </NavLink>)

        //menuItem.children
        const menuChild = menuItem.children && (
            <ul
                className={`nav-sub ${menuItem.active && "open"} ${menuItem.highlighted ? "highlighted" : ""}`}
                style={
                    menuItem.active
                        ? { display: "block" }
                        : { display: "none" }
                }
            >
                {menuItem.children.map((childrenItem, index) => {
                    return (
                        <li
                            key={index}
                            className={`nav-sub-item ${childrenItem.selected && "active show"} ${menuItem.highlighted ? "highlighted" : ""}`}
                        >

                            {/*roleCanViewDeviceSetup && printChildrenMenu(menuItem, childrenItem)*/}
                            {printChildrenMenu(menuItem, childrenItem)}



                        </li>
                    );
                })}
            </ul>)

        //return menuSubtitles || menuLink || menuChild
        return (
            <>
                {menuSubtitles}
                {menuLink}
                {menuChild}
            </>
        )

    }


    const sidebarLinks = (sideMenuItems = []) => {
        return (
            sideMenuItems.map((Item, index) => {
                const sidebarKey = index + Math.random() * 100

                //PRINT MAIN SIDEBAR TITLES
                const sidebarHeader = <li className="nav-header">
                    <span className="nav-label">{Item.menutitle}</span>
                </li>

                return (
                    <React.Fragment key={sidebarKey}>

                        {sidebarHeader}

                        {Item.Items.map((menuItem, i) => (
                            <li
                                className={`nav-item ${menuItem.selected ? "active" : ""} ${menuItem.highlighted ? "highlighted" : ""}`}
                                key={i}
                            >
                                {printSideMenu(menuItem)}
                            </li>
                        ))}

                    </React.Fragment>
                )
            })
        )
    }


    const sideMenuLogo = (
        <div className="sidemenu-logo">
            <Link
                className="main-logo"
                //to={`${process.env.PUBLIC_URL}/dashboard/ `}
                to="#"
            >
                <img
                    src={smarpayLightLogo}
                    className="header-brand-img desktop-logo"
                    alt={"logo1"}
                />

                <img
                    src={iconLight}
                    className="header-brand-img icon-logo"
                    alt={"logo-2"}
                />

                <img
                    src={smarpayLogoSmall}
                    className="header-brand-img desktop-logo theme-logo"
                    alt={"logo-3"}
                />
                <img
                    src={logoIcon}
                    className="header-brand-img icon-logo theme-logo"
                    alt={"logo-4"}
                />
            </Link>
        </div>
    )

    return {
        menuItemsState,
        toggleSidemenu,
        clearMenuActive,
        updateMenuItems,
        printChildrenSubmenu,
        printChildrenMenu,
        printSideMenu,
        sidebarLinks,
        sideMenuLogo
    };
}

export default useSideMenu;
